import ConfigService from '../index'
class IDSecureService extends ConfigService {
    constructor(){
        super('controlid/api/v1/')
    }
    async get_devices(params){
        return await this.get('idsecure/get_devices/', params)
    }
    async get_device_child(params){
        return await this.get('idsecure/get_device_child/', params)
    }
    async test_connect(payload){
        return await this.post('idsecure/test_connect/', payload)
    }
    async test_photo(data){
        /* generic não requisita autenticação */
        return await this.genericPostRequest('controlid/api/v1/idsecure/test_photo/', data)
    }
    async list_visitantes(params){
        return await this.get('visitante/list_visitantes/', params)
    }
    async list_visitantes_grupos(){
        return await this.get('visitante/list_visitantes_groups/')
    }
    async get_pessoa(matricula){
        return await this.get(`pessoa/${matricula}/read_pessoa/`)
    }
    async get_visitante(id){
        return await this.get(`visitante/${id}/read_visitante/`)
    }
    async post_visitante(data){
        return await this.post('visitante/create_visitante/', data)
    }
    async post_visitante_solicitacao(data){
        return await this.post('visitante/create_visitante_by_solicitacao/', data)
    }
    async put_visitante(id, data){
        return await this.put(`visitante/${id}/update_visitante/`, data)
    }
    async get_log_visitante(idDevice){
        return await this.get(`logvisitante/${idDevice}/log_visitante/`)
    }
    async save_to_rm(data){
        return await this.post('idsecure/save_to_rm/', data)
    }
}
export default IDSecureService
